module.exports = __webpack_public_path__ + "static/3profile-47b60627859ef982d218a73cc526d813.gif";